import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';

import { DistribuidorFormComponent } from './pages/distribuidor-form/distribuidor-form.component';
import { FacturaFormComponent } from './pages/factura-form/factura-form.component';
import { ProductoFormComponent } from './pages/producto-form/producto-form.component';
import { RegisterComponent } from './auth/register/register.component';
import { BarraNavegacionComponent } from './component/barra-navegacion/barra-navegacion.component';
import { SigninComponent } from './auth/signin/signin.component';
import { FacturaLstComponent } from './pages/factura-lst/factura-lst.component';
import { FacturaLstEmpresaComponent } from './pages/factura-lst-empresa/factura-lst-empresa.component';
import { TrazabilidadFormComponent } from './pages/trazabilidad-form/trazabilidad-form.component';
import { ProductosFacuradosLstComponent } from './pages/productos-facurados-lst/productos-facurados-lst.component';
import { AdminFormComponent } from './auth/admin-form/admin-form.component';
import { EmpresaFormComponent } from './auth/empresa-form/empresa-form.component';
import { DistribuidorFrmComponent } from './pages/distribuidor-frm/distribuidor-frm.component';
import { LoaderModule } from './shared/loader/loader.module';
import { DistribuidorLstComponent } from './pages/distribuidor-lst/distribuidor-lst.component';

registerLocaleData(localeEsMx);
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DistribuidorFormComponent,
    FacturaFormComponent,
    ProductoFormComponent,
    RegisterComponent,
    BarraNavegacionComponent,
    SigninComponent,
    FacturaLstComponent,
    FacturaLstEmpresaComponent,
    TrazabilidadFormComponent,
    ProductosFacuradosLstComponent,
    AdminFormComponent,
    EmpresaFormComponent,
    DistribuidorFrmComponent,
    DistribuidorLstComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    CheckboxModule,
    FormsModule,
    DropdownModule,
    CalendarModule,
    DividerModule,
    TableModule,
    DialogModule,
    ToastModule,
    LoaderModule,
  ],
  providers: [MessageService, { provide: LOCALE_ID, useValue: 'es-mx' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
